<template>
  <div>
    <v-container grid-list-md>
      <v-layout row wrap>
        <v-flex
          xs12
          text-xs-center
          layout
          align-center
          justify-center
        >
          <v-avatar
            size="170"
            color="white"
            tile
          >
            <img :src="logoUrl">
          </v-avatar>
        </v-flex>
        <v-flex
          xs12
          text-xs-center
        >
          <h3>{{ profile.storeName }} ({{ profile.storeCurrencyCode }})</h3>
          {{ profile.firstName }} {{ profile.lastName }} ({{ profile.roleName }})
        </v-flex>
      </v-layout>
    </v-container>
    <v-list>
      <v-list-group
        v-if="accessSales"
        prepend-icon="shopping_cart"
        :value="expandSales"
      >
        <v-list-tile slot="activator">
          <v-list-tile-title>Sales</v-list-tile-title>
        </v-list-tile>
        <v-list-tile to="/orders/in-progress" exact>
          <v-list-tile-action></v-list-tile-action>
          <v-list-tile-title>In-progress</v-list-tile-title>
        </v-list-tile>
        <v-list-tile to="/orders/shipped" exact>
          <v-list-tile-action></v-list-tile-action>
          <v-list-tile-title>Shipped</v-list-tile-title>
        </v-list-tile>
        <v-list-tile to="/orders/all" exact>
          <v-list-tile-action></v-list-tile-action>
          <v-list-tile-title>All</v-list-tile-title>
        </v-list-tile>
      </v-list-group>
      <v-list-group
        prepend-icon="message"
        :value="expandTicket"
      >
        <v-list-tile slot="activator">
          <v-list-tile-title>
            Tickets <span>({{ parseInt(profile.pendingTicketCount) + parseInt(profile.repliedTicketCount) }})</span>
          </v-list-tile-title>
          <v-list-tile-avatar v-if="(parseInt(profile.pendingTicketNewMessageCount) + parseInt(profile.repliedTicketNewMessageCount) + parseInt(profile.otherTicketNewMessageCount) + parseInt(profile.closedTicketNewMessageCount)) > 0">
            <v-badge color="red" small>
              <template v-slot:badge>
                <span>{{ (parseInt(profile.pendingTicketNewMessageCount) + parseInt(profile.repliedTicketNewMessageCount) + parseInt(profile.otherTicketNewMessageCount) + parseInt(profile.closedTicketNewMessageCount)) }}</span>
              </template>
            </v-badge>
          </v-list-tile-avatar>
        </v-list-tile>
        <v-list-tile to="/tickets/pending" exact>
          <v-list-tile-action></v-list-tile-action>
          <v-list-tile-title>
            Pending <span>({{ profile.pendingTicketCount }})</span>
          </v-list-tile-title>
          <v-list-tile-avatar v-if="profile.pendingTicketNewMessageCount > 0">
            <v-badge color="red" small>
              <template v-slot:badge>
                <span>{{ profile.pendingTicketNewMessageCount }}</span>
              </template>
            </v-badge>
          </v-list-tile-avatar>
        </v-list-tile>
        <v-list-tile to="/tickets/replied" exact>
          <v-list-tile-action></v-list-tile-action>
          <v-list-tile-title>
            Replied <span>({{ profile.repliedTicketCount }})</span>
          </v-list-tile-title>
          <v-list-tile-avatar v-if="profile.repliedTicketNewMessageCount > 0">
            <v-badge color="red" small>
              <template v-slot:badge>
                <span>{{ profile.repliedTicketNewMessageCount }}</span>
              </template>
            </v-badge>
          </v-list-tile-avatar>
        </v-list-tile>
        <v-list-tile to="/tickets/others" exact>
          <v-list-tile-action></v-list-tile-action>
          <v-list-tile-title>Others</v-list-tile-title>
          <v-list-tile-avatar v-if="profile.otherTicketNewMessageCount > 0">
            <v-badge color="red" small>
              <template v-slot:badge>
                <span>{{ profile.otherTicketNewMessageCount }}</span>
              </template>
            </v-badge>
          </v-list-tile-avatar>
        </v-list-tile>
        <v-list-tile to="/tickets/closed" exact>
          <v-list-tile-action></v-list-tile-action>
          <v-list-tile-title>Closed</v-list-tile-title>
          <v-list-tile-avatar v-if="profile.closedTicketNewMessageCount > 0">
            <v-badge color="red" small>
              <template v-slot:badge>
                <span>{{ profile.closedTicketNewMessageCount }}</span>
              </template>
            </v-badge>
          </v-list-tile-avatar>
        </v-list-tile>
        <v-list-tile v-if="accessTicket" to="/tickets/all" exact>
          <v-list-tile-action></v-list-tile-action>
          <v-list-tile-title>All</v-list-tile-title>
        </v-list-tile>
        <v-list-tile v-if="createTicket" to="/ticket" exact>
          <v-list-tile-action></v-list-tile-action>
          <v-list-tile-title>Create Ticket</v-list-tile-title>
        </v-list-tile>
      </v-list-group>
      <v-list-group
        v-if="accessProduct"
        prepend-icon="widgets"
        :value="expandProduct"
      >
        <v-list-tile slot="activator">
          <v-list-tile-title>Products</v-list-tile-title>
        </v-list-tile>
        <v-list-tile to="/products" exact>
          <v-list-tile-action></v-list-tile-action>
          <v-list-tile-title>Manage Products</v-list-tile-title>
        </v-list-tile>
        <v-list-tile to="/markups" exact>
          <v-list-tile-action></v-list-tile-action>
          <v-list-tile-title>Manage Markups</v-list-tile-title>
        </v-list-tile>
        <v-list-tile to="/suppliers" exact>
          <v-list-tile-action></v-list-tile-action>
          <v-list-tile-title>Manage Suppliers</v-list-tile-title>
        </v-list-tile>
      </v-list-group>
      <v-list-group
        v-if="accessTransaction"
        prepend-icon="store"
        :value="expandStore"
      >
        <v-list-tile slot="activator">
          <v-list-tile-title>My Store</v-list-tile-title>
        </v-list-tile>
        <v-list-tile to="/store/transactions" exact>
          <v-list-tile-action></v-list-tile-action>
          <v-list-tile-title>Transaction List</v-list-tile-title>
        </v-list-tile>
      </v-list-group>
      <v-list-group
        v-if="accessAdmin"
        prepend-icon="person"
        :value="expandAdmin"
      >
        <v-list-tile slot="activator">
          <v-list-tile-title>Admin</v-list-tile-title>
        </v-list-tile>
        <v-list-tile to="/admins" exact>
          <v-list-tile-action></v-list-tile-action>
          <v-list-tile-title>Manage Admin</v-list-tile-title>
        </v-list-tile>
        <v-list-tile to="/admin" exact>
          <v-list-tile-action></v-list-tile-action>
          <v-list-tile-title>Create Admin</v-list-tile-title>
        </v-list-tile>
      </v-list-group>
      <v-list-group
        prepend-icon="face"
        :value="expandMyAccount"
      >
        <v-list-tile slot="activator">
          <v-list-tile-title>My Account</v-list-tile-title>
        </v-list-tile>
        <v-list-tile to="/me/profile" exact>
          <v-list-tile-action></v-list-tile-action>
          <v-list-tile-title>Update Profile</v-list-tile-title>
        </v-list-tile>
        <v-list-tile to="/me/password" exact>
          <v-list-tile-action></v-list-tile-action>
          <v-list-tile-title>Change Password</v-list-tile-title>
        </v-list-tile>
      </v-list-group>

      <v-list-group
        prepend-icon="help_outline"
        :value="expandHelp"
      >
        <v-list-tile slot="activator">
          <v-list-tile-title>Help</v-list-tile-title>
        </v-list-tile>

           <v-list-tile  to="/help/sales" exact v-if="accessSales" >
          <v-list-tile-action></v-list-tile-action>
          <v-list-tile-title > Sales</v-list-tile-title>
          </v-list-tile>

        <v-list-tile to="/help/tickets" exact v-if="accessTicket">
          <v-list-tile-action></v-list-tile-action>
          <v-list-tile-title> Tickets</v-list-tile-title>
        </v-list-tile>
          <v-list-tile to="/help/products" exact v-if="accessProduct">
          <v-list-tile-action></v-list-tile-action>
          <v-list-tile-title> Products</v-list-tile-title>
        </v-list-tile>
         <v-list-tile to="/help/markup" exact v-if="accessProduct">
          <v-list-tile-action></v-list-tile-action>
          <v-list-tile-title> Markup</v-list-tile-title>
        </v-list-tile>
         <v-list-tile to="/help/supplier" exact v-if="accessProduct">
          <v-list-tile-action></v-list-tile-action>
          <v-list-tile-title> Supplier</v-list-tile-title>
        </v-list-tile>
          <v-list-tile to="/help/my_store" exact v-if="accessTransaction">
          <v-list-tile-action></v-list-tile-action>
          <v-list-tile-title>My Store</v-list-tile-title>
        </v-list-tile>
          <v-list-tile to="/help/my_account">
          <v-list-tile-action></v-list-tile-action>
          <v-list-tile-title> My Account</v-list-tile-title>
        </v-list-tile>
      </v-list-group>

      <v-list-tile @click="logout()">
        <v-list-tile-action>
          <v-icon>exit_to_app</v-icon>
        </v-list-tile-action>
        <v-list-tile-title>Log out</v-list-tile-title>
      </v-list-tile>
    </v-list>
    <div class="caption font-weight-light pa-3 mt-4 grey--text text--darken-3">
      Seller Version 1.9.0
    </div>
  </div>
</template>

<script>
import router from '../router'
import { EventBus } from '../main'

export default {
  data () {
    return {
      logoUrl: process.env.VUE_APP_LOGO_URL,
      profile: this.$store.getters.getProfile,
      autoloadInterval: null,
      expandSales: false,
      expandTicket: false,
      expandProduct: false,
      expandAdmin: false,
      expandStore: false,
      expandMyAccount: false,
      expandHelp: false,
      accessProduct: false,
      accessCategory: false,
      accessSales: false,
      accessTicket: false,
      createTicket: false,
      accessTransaction: false,
      accessCustomer: false,
      accessAdmin: false

    }
  },
  created () {
    var _this = this
    EventBus.$on('profileUpdated', profile => {
      _this.profile = profile
    })
    EventBus.$on('logout', function () {
      clearInterval(_this.autoloadInterval)
    })
    EventBus.$on('disableProfileRefresh', function () {
      clearInterval(_this.autoloadInterval)
    })
  },
  mounted () {
    this.$store.dispatch('UPDATE_PROFILE')
    this.showMenu()
    this.expandMenu()

    var _this = this
    _this.autoloadInterval = setInterval(function () {
      _this.$store.dispatch('UPDATE_PROFILE')
    }, (2 * 60 * 1000))
  },
  methods: {
    expandMenu: function () {
      var fullPath = this.$router.currentRoute.fullPath
      var paths = fullPath.split('/')
      console.log(paths)
      if (paths[1] === 'product' || paths[1] === 'products' || paths[1] === 'markup' || paths[1] === 'markups' || paths[1] === 'supplier' || paths[1] === 'suppliers') {
        this.expandProduct = true
      } else if (paths[1] === 'order' || paths[1] === 'orders') {
        this.expandSales = true
      } else if (paths[1] === 'ticket' || paths[1] === 'tickets') {
        this.expandTicket = true
      } else if (paths[1] === 'store') {
        this.expandStore = true
      } else if (paths[1] === 'admin' || paths[1] === 'admins') {
        this.expandAdmin = true
      } else if (paths[1] === 'me') {
        this.expandMyAccount = true
      } else if (paths[1] === 'help') {
        this.expandHelp = true
      }
    },
    showMenu: function () {
      var userProfile = this.getUserProfile()
      for (var i = 0, len = userProfile.permissions.length; i < len; i++) {
        if (userProfile.permissions[i].permissionId === 'PEM-SALES' && userProfile.permissions[i].isRead === '1') {
          this.accessSales = true
        }
        if (userProfile.permissions[i].permissionId === 'PEM-TICKET' && userProfile.permissions[i].isRead === '1') {
          this.accessTicket = true
        }
        if (userProfile.permissions[i].permissionId === 'PEM-TICKET' && userProfile.permissions[i].isCreate === '1') {
          this.createTicket = true
        }
        if (userProfile.permissions[i].permissionId === 'PEM-PRODUCT' && userProfile.permissions[i].isRead === '1') {
          this.accessProduct = true
        }
        if (userProfile.permissions[i].permissionId === 'PEM-CATEGORY' && userProfile.permissions[i].isRead === '1') {
          this.accessCategory = true
        }
        if (userProfile.permissions[i].permissionId === 'PEM-TRANSACTION' && userProfile.permissions[i].isRead === '1') {
          this.accessTransaction = true
        }
        if (userProfile.permissions[i].permissionId === 'PEM-CUSTOMER' && userProfile.permissions[i].isRead === '1') {
          this.accessCustomer = true
        }
        if (userProfile.permissions[i].permissionId === 'PEM-USER' && userProfile.permissions[i].isRead === '1') {
          this.accessAdmin = true
        }
      }
    },
    logout: function () {
      this.$store.dispatch('AUTH_LOGOUT')
        .then(() => {
          clearInterval(this.autoloadInterval)
          router.push('/login')
        })
    }
  }
}
</script>

<style scoped>
</style>
